import React from 'react';
import PropTypes from 'prop-types';
import DropdownItem from 'components/DropdownItem';

import './style.scss';

const FilterMatchedMenuItem = ({ name, options, handleClick }) => (
  <React.Fragment>
    {options.map(item => (
      <DropdownItem
        isDisabled={item.disabled}
        key={item.label}
        onClick={() => handleClick(item, name)}
      >
        {item.label}
      </DropdownItem>
    ))}
  </React.Fragment>
);

FilterMatchedMenuItem.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
  handleClick: PropTypes.func,
};

export default FilterMatchedMenuItem;
